module.exports = __webpack_public_path__ + "media/images/f_2-e903a7fb13674c7a7e552094d058e53c.png";